import { Briefcase } from 'lucide-react';
import { useProfile } from '@/api/profile';
import { Combobox } from '@/components/shared/combobox';

type Props = {
  value: number | undefined;
  onChange: (positionId: number | undefined) => void;
};

export function PositionFilter({ value, onChange }: Props) {
  const { data: profile } = useProfile();

  const positions = profile?.user_positions ?? [];
  if (positions.length < 2) return null;

  return (
    <div className="flex items-center gap-4 rounded-xl border border-border bg-card p-4">
      <Briefcase className="h-5 w-5 shrink-0 text-muted-foreground" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-foreground">Filtrar por puesto</p>
        <p className="text-xs text-muted-foreground">Tienes {positions.length} puestos asignados</p>
      </div>
      <Combobox
        value={value != null ? String(value) : ''}
        onChange={(v) => onChange(v ? Number(v) : undefined)}
        options={positions.map((up) => ({
          value: String(up.position.id),
          label: up.position.name,
          sublabel: up.position.code,
        }))}
        placeholder="Todos los puestos"
        clearable
        className="w-64"
      />
    </div>
  );
}
